import React from 'react'
import Label from "components/general/Label";
import { ColumnMove, ColumnName, ColumnNoc, ColumnResult,  ColumnExpander } from "components/common/TableColumns"
import { findArray } from 'helpers/utils'
import SportCode from "components/common/SportCode"
import FavButton from "components/sports/glf/component/FavButton"

function ColumnRank(disableSort){
    return (
        {
            Header: <Label data="HeaderRank" />,
            accessor: 'rank',
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: disableSort,
            id: 'Rank',
            Cell: (props) => {
                const row = props.cell.row.original
                const rankEqual = row?.resultRankEqual === 'Y' ? 'T' : ''
                const rank = (row?.resultType === 'IRM')
                    ? <SportCode discipline="GLF" code={row?.resultIrm} entity="@IRM" abbr={true}/>
                    : row?.resultRank 
                        ? rankEqual+row?.resultRank 
                        : ''
                return rank
            }
        }
    )
}

function ColumnToPar(disableSort){
    return (
        {
            Header: <Label data={"HeaderToPar"} />,        
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: disableSort,
            id: 'toPar',
            accessor: 'sortOrder',
            Cell: (props) => {
                let value = findArray(props.cell.row.original?.extendedResults, { er_code: ['TO_PAR']})
                return value.er_value
            }            
        }
    )
}

function ColumnToday(_currentUnit, disableSort){
    return (
        {
            Header: <Label data={"HeaderToday"} />,        
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: disableSort,
            id: 'today',
            accessor: 'sortOrder',
            Cell: (props) => {
                let resultItem = props.cell.row.original?.items?.find(item => item?.eventUnit?.code === _currentUnit)
                let value = (resultItem) ? findArray(resultItem?.extendedResults, { er_code: ['TO_PAR']})?.er_value : ''
                return value
            }            
        }
    )
}

function ColumnThru(disableSort){
    return (
        {
            Header: <Label data={"HeaderThru"} />,
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: disableSort,
            id: 'thru',
            accessor: (props) => (
                props?.extendedResults.find(row => row.er_code === 'THRU')?.er_value
            ),
            Cell: (props) => {
                let value = findArray(props.cell.row.original?.extendedResults, { er_code: ['THRU']})
                return value.er_value
            }            
        }
    )
}

function ColumnRound(round, _phase, disableSort){
    const _units = [ 
        _phase + '000100--'
        ,_phase + '000200--'
        ,_phase + '000300--'
        ,_phase + '000400--'
    ]
    const _rsc = _units[round-1]

    return (    
        {
            Header: "R"+round,
            className: 'text-end',
            headerClassName: 'text-end',
            disableSortBy: disableSort,
            id: 'Round'+round,
            accessor: (props) => {
                if(props?.items !== undefined) {
                    return (props?.items?.find(item => item?.eventUnit?.code === _rsc)?.resValue)
                }
            },
            Cell: (props) => {
                let resultItem = props.cell.row.original?.items?.find(item => item?.eventUnit?.code === _rsc)
                return resultItem?.resValue
            }            
        }
    )
}

function ColumnTotal(disableSort){
    return (
        {
            Header: <Label data="HeaderTotal" />,
            accessor: 'SortOrder',
            className : 'text-end',
            headerClassName : 'text-end w-10',
            disableSortBy: disableSort,
            id: 'Result',
            Cell: (props) => {
                let resultType = (props.cell.row.original.resultType)
                let result = (props.cell.row.original.resultData)
                return resultType !== 'IRM' ? result : ''                
            }
        }
    )
}

function ColumnFav(favData, setFavData){
    return (
        {
            Header: <Label data={"HeaderFav"} />,
            className: 'text-center',
            headerClassName: 'text-center w-5',
            id: 'fav',
            Cell: (props) => {
                const participant = props.cell.row.original?.participant?.code
                return <FavButton participant={participant} favData={favData} setFavData={setFavData}/>
            }            
        }
    )
}

export function TableColumnsSM(_currentUnit, _phase) {
    return (
        [
            ColumnRank(true),
            ColumnName({disableSort: true}),
            ColumnToPar(true),
            ColumnThru(true),
            ColumnToday(_currentUnit, true),
            ColumnExpander({type: 'alwaysTrue', allExpanded: false})
        ]
    )
}

export function TableColumns(_currentUnit, _phase, favData, setFavData) {
    return (
        [
            ColumnRank(false),
            ColumnMove({type:'cumulativeResults'}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnToPar(false),
            ColumnThru(false),
            ColumnToday(_currentUnit,false),
            ColumnRound(1, _phase,false),
            ColumnRound(2, _phase,false),
            ColumnRound(3, _phase,false),
            ColumnRound(4, _phase,false),
            ColumnTotal(false),
            ColumnExpander({type: 'alwaysTrue', allExpanded: false}),
            ColumnFav(favData, setFavData)
            
        ]
    )
}

